var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerMacNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 60,
    viewBox: "0 0 188 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_21567)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.258301 -0.163086C62.4082 -0.163086 125.075 -0.163086 187.742 -0.163086C187.742 14.8369 187.742 29.8369 187.742 44.8369C125.075 44.8369 62.4082 44.8369 -0.258301 44.8369C-0.258301 29.8369 -0.258301 14.8369 -0.258301 -0.163086Z",
    fill: "#010000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9946 0.489122C93.6298 -0.0603276 99.7413 1.57011 104.33 5.38043C105.229 6.2965 105.832 7.27476 106.137 8.31521C100.931 8.17714 95.7665 8.34019 90.643 8.80434C88.2573 10.53 86.2771 12.4322 84.7034 14.5109C84.3326 14.8208 83.9023 14.8752 83.4122 14.6739C81.7305 12.5491 79.6646 10.5926 77.2144 8.80434C75.825 8.55296 74.4481 8.28123 73.0825 7.98912C75.6107 4.21695 79.9151 1.71696 85.9946 0.489122Z",
    fill: "#FBC737"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.709 11.25C97.4358 10.926 102.256 10.8173 107.171 10.9239C107.323 11.6528 107.15 12.305 106.654 12.8804C106.654 12.3369 106.654 11.7934 106.654 11.25C102.006 11.25 97.3573 11.25 92.709 11.25Z",
    fill: "#C79D2B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7088 11.2501C97.3571 11.2501 102.005 11.2501 106.654 11.2501C106.654 11.7936 106.654 12.337 106.654 12.8805C105.414 17.4162 101.282 20.4054 94.2582 21.8479C80.9603 22.9294 73.7296 19.2881 72.5659 10.924C73.4434 10.8717 74.3044 10.9261 75.1483 11.087C76.956 13.2624 79.022 15.3276 81.3461 17.2827C83.5226 18.0227 85.5023 17.8597 87.2857 16.7936C89.1063 14.9249 90.914 13.077 92.7088 11.2501Z",
    fill: "#FBC637"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.5 28.8585C168.215 28.6774 171.83 28.9492 175.346 29.6737C176.301 30.0301 177.162 30.4649 177.929 30.9781C176.379 31.6846 174.83 32.3911 173.28 33.0976C168.794 31.1963 164.748 31.5224 161.143 34.0759C159.15 37.0381 160.441 39.2665 165.016 40.7607C168.335 41.2987 171.176 40.8096 173.538 39.2933C174.863 40.0195 176.326 40.6175 177.929 41.0868C178.42 41.3209 178.505 41.5925 178.187 41.902C175.174 43.4108 171.73 44.0629 167.857 43.8585C157.806 43.8187 153.157 40.6664 153.912 34.402C155.89 31.3609 159.419 29.513 164.5 28.8585Z",
    fill: "#F9F8F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.774902 29.5109C3.08934 29.1365 5.49959 29.0821 8.00567 29.3479C10.2637 32.3621 12.5879 35.3512 14.9782 38.3153C17.1217 35.3906 19.2737 32.4557 21.4342 29.5109C23.6462 29.1874 25.8843 29.0787 28.1485 29.1849C24.8071 34.0563 21.1917 38.8387 17.3024 43.5327C15.4716 43.9537 13.6639 43.9537 11.8793 43.5327C8.15411 38.8289 4.45264 34.1547 0.774902 29.5109Z",
    fill: "#F7F5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8737 29.1846C50.8737 30.1628 50.8737 31.1411 50.8737 32.1194C46.6467 32.0131 42.5149 32.1218 38.4781 32.4454C38.4781 33.2062 38.4781 33.9673 38.4781 34.728C42.4378 34.728 46.3975 34.728 50.3572 34.728C50.3572 35.8149 50.3572 36.9021 50.3572 37.9889C46.3975 37.9889 42.4378 37.9889 38.4781 37.9889C38.4781 38.8586 38.4781 39.7279 38.4781 40.5976C42.6874 40.9214 46.9914 41.03 51.3902 40.9237C51.3902 41.7934 51.3902 42.6627 51.3902 43.5324C45.0202 43.5324 38.6502 43.5324 32.2803 43.5324C32.2803 38.7497 32.2803 33.9673 32.2803 29.1846C38.4781 29.1846 44.6759 29.1846 50.8737 29.1846Z",
    fill: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5329 29.5106C67.0566 29.5106 62.5807 29.5106 58.1044 29.5106C58.1044 34.1844 58.1044 38.8586 58.1044 43.5324C59.9983 43.5324 61.8917 43.5324 63.7857 43.5324C61.8241 43.8529 59.7582 43.9618 57.5879 43.8585C57.5879 38.9672 57.5879 34.0759 57.5879 29.1846C62.3302 29.0781 66.9786 29.1867 71.5329 29.5106Z",
    fill: "#D1C9BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5331 29.5108C76.0812 29.3942 78.6636 30.7529 79.2803 33.5869C78.8144 35.9458 76.7485 37.3588 73.0825 37.826C75.4201 39.6821 77.658 41.5845 79.7968 43.5326C77.405 43.9115 74.9945 43.9656 72.566 43.6956C70.6938 41.9298 68.8861 40.1364 67.143 38.3152C66.0888 38.0142 64.9696 37.9056 63.7858 37.9891C63.7858 39.837 63.7858 41.6846 63.7858 43.5326C61.8919 43.5326 59.9984 43.5326 58.1045 43.5326C58.1045 38.8588 58.1045 34.1846 58.1045 29.5108C62.5809 29.5108 67.0567 29.5108 71.5331 29.5108Z",
    fill: "#FBFAF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.489 29.5111C98.3901 29.5111 95.2912 29.5111 92.1923 29.5111C92.1923 34.1849 92.1923 38.859 92.1923 43.5328C92.0203 43.5328 91.8478 43.5328 91.6758 43.5328C91.6758 38.7501 91.6758 33.9677 91.6758 29.185C95.0443 29.0795 98.3152 29.1882 101.489 29.5111Z",
    fill: "#DACCB9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9067 33.7501C98.6551 33.4328 98.3969 33.1067 98.1319 32.7718C97.8737 36.3571 97.7874 39.9441 97.8737 43.5327C95.9798 43.5327 94.0863 43.5327 92.1924 43.5327C92.1924 38.8589 92.1924 34.1847 92.1924 29.5109C95.2913 29.5109 98.3902 29.5109 101.489 29.5109C103.32 32.3669 105.299 35.193 107.429 37.9892C109.788 35.1728 111.94 32.2925 113.885 29.3479C116.979 29.185 120.078 29.1306 123.181 29.1848C123.181 34.0761 123.181 38.9675 123.181 43.8588C121.115 43.8588 119.05 43.8588 116.984 43.8588C117.07 40.3788 116.984 36.9004 116.725 33.424C114.345 36.7559 112.106 40.1257 110.011 43.5327C108.29 43.9673 106.568 43.9673 104.846 43.5327C102.711 40.3025 100.731 37.0416 98.9067 33.7501Z",
    fill: "#FAF9F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.995 43.2063C130.704 43.6283 128.467 43.6283 126.28 43.2063C129.663 38.6081 133.192 34.0429 136.868 29.5106C138.762 29.0759 140.656 29.0759 142.55 29.5106C146.238 34.2748 149.767 39.0572 153.137 43.8585C150.762 43.9563 148.438 43.8477 146.165 43.5324C143.927 40.489 141.689 37.4453 139.451 34.402C137.284 37.3537 135.132 40.2885 132.995 43.2063Z",
    fill: "#F8F7F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8736 29.1846C51.3795 30.2035 51.5517 31.2905 51.3901 32.4454C47.0861 32.4454 42.782 32.4454 38.478 32.4454C42.5148 32.1218 46.6467 32.0131 50.8736 32.1194C50.8736 31.1411 50.8736 30.1628 50.8736 29.1846Z",
    fill: "#8C8273"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9506 32.1196C71.7133 32.1706 72.7462 32.9857 72.0495 34.5653C71.0496 34.8304 70.0166 34.9934 68.9506 35.0544C67.4011 35.0544 65.8517 35.0544 64.3022 35.0544C64.3022 34.0762 64.3022 33.0979 64.3022 32.1196C65.8517 32.1196 67.4011 32.1196 68.9506 32.1196Z",
    fill: "#070503"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.577 29.1846C185.486 29.335 186.777 30.3133 186.451 32.1194C183.641 33.9895 181.661 33.7178 180.511 31.3041C180.477 30.2973 181.166 29.5908 182.577 29.1846Z",
    fill: "#F0E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.577 32.4457C183.068 31.6158 183.585 31.6158 184.127 32.4457C183.551 32.8618 183.035 32.8618 182.577 32.4457Z",
    fill: "#FCC841"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.577 29.8369C185.611 29.9065 186.386 30.7761 184.901 32.4456C184.478 31.8048 184.22 31.1526 184.127 30.4891C183.61 30.2717 183.094 30.0543 182.577 29.8369Z",
    fill: "#FECC4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.577 29.8369C183.094 30.0543 183.61 30.2717 184.127 30.4891C183.93 30.6955 183.758 30.9129 183.61 31.1413C183.253 30.97 182.994 30.7526 182.835 30.4891C182.58 31.1324 182.493 31.7845 182.577 32.4456C181.944 32.2329 181.6 31.8525 181.544 31.3043C181.444 30.6495 181.789 30.1604 182.577 29.8369Z",
    fill: "#FFDE96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9505 32.1195C67.401 32.1195 65.8516 32.1195 64.3021 32.1195C64.3021 33.0977 64.3021 34.076 64.3021 35.0542C65.8516 35.0542 67.401 35.0542 68.9505 35.0542C67.3365 35.3735 65.615 35.4824 63.7856 35.3803C63.7856 34.1846 63.7856 32.9891 63.7856 31.7934C65.615 31.6914 67.3365 31.8001 68.9505 32.1195Z",
    fill: "#AEA089"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9066 33.7502C98.3932 37.061 98.2207 40.4305 98.3901 43.8589C96.0494 43.9626 93.8109 43.854 91.6758 43.5328C91.8478 43.5328 92.0203 43.5328 92.1923 43.5328C94.0862 43.5328 95.9796 43.5328 97.8736 43.5328C97.7873 39.9443 97.8736 36.3573 98.1318 32.772C98.3968 33.1069 98.655 33.433 98.9066 33.7502Z",
    fill: "#A29073"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.313 35.7065C83.0674 35.7065 85.8223 35.7065 88.5767 35.7065C88.5767 36.7934 88.5767 37.8806 88.5767 38.9674C85.8223 38.9674 83.0674 38.9674 80.313 38.9674C80.313 37.8806 80.313 36.7934 80.313 35.7065Z",
    fill: "#F7F3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4781 40.5977C42.9543 40.5977 47.4304 40.5977 51.9066 40.5977C51.9066 41.6845 51.9066 42.7717 51.9066 43.8585C45.2728 43.9658 38.7306 43.8569 32.2803 43.5324C38.6502 43.5324 45.0202 43.5324 51.3902 43.5324C51.3902 42.6628 51.3902 41.7934 51.3902 40.9237C46.9914 41.03 42.6874 40.9215 38.4781 40.5977Z",
    fill: "#A7A19B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.28 43.2065C128.466 43.6285 130.704 43.6285 132.994 43.2065C132.015 43.6321 130.809 43.8493 129.379 43.8587C128.174 43.7501 126.969 43.6412 125.764 43.5326C125.828 43.3347 126 43.2261 126.28 43.2065Z",
    fill: "#90826B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_21567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerMacNew);
export default __webpack_public_path__ + "static/media/VerMac_new.c37dff88edef0d5117b4fbc9e54d5623.svg";
export { ForwardRef as ReactComponent };